// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"PI-z","smallCardRow":"QI-z","largeCardRow":"RI-z","productSearchRow":"SI-z","curatedRow":"TI-z"};